import { render } from "./legacy.md?vue&type=template&id=38d9e390"
import script from "./legacy.md?vue&type=script&lang=js"
export * from "./legacy.md?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__